import { render, staticRenderFns } from "./RaceListHeaderSection.vue?vue&type=template&id=5df8a5f0&scoped=true"
import script from "./RaceListHeaderSection.vue?vue&type=script&lang=ts"
export * from "./RaceListHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./RaceListHeaderSection.vue?vue&type=style&index=0&id=5df8a5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8a5f0",
  null
  
)

export default component.exports